import React from "react";
import { useEffect, useState, useRef } from "react";
import Storage from "@/app/core/util/Storage";
import { toast } from "react-toastify";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import DeliveryModal from "@/app/core/layouts/main-components/delivery/DeliveryModal";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import Functions from "@/app/core/util/Functions";
import { FedexController } from "@/app/core/base/controllers/FedexController";
import BoxItem from "@/app/core/layouts/main-components/delivery/BoxItem";
import { FedexHelper } from "@/app/core/util/helpers/Fedex/FedexHelper";
import CheckMobile from "@/app/core/util/Screen";

export default function TrackingComponent(props) {
    const userData = Storage.getUserData();
    const [data, setData] = useState({});
    const [progress, setProgress] = useState(0);
    const [timeline, setTimeline] = useState([]);
    const [deliveryId, setDeliveryId] = useState(null);
    const [results, setResults] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadQuery()
    }, []);

    useEffect(() => {
        if (data.fromQuery == true) {
            goSearch()
        }
    }, [data]);

    function loadQuery() {
        if (props != undefined && props.location != undefined) {

            let param = props.location.search;
            let awb = "";
            if (param.split("?")[1] !== undefined) {

                let item = param.split("?")[1].split("&");
                for (var i = 0; i < item.length; i++) {
                    let parr = item[i].split("=");
                    if (parr[0] == "query" && parr[0] != undefined) {
                        awb = decodeURIComponent(parr[1]);
                    }
                }

                if (awb != undefined && awb != null) {
                    setData({ query: awb, fromQuery: true })
                }
            }
        }
    }

    function handleChange(evt) {
        setData(OnDataChange(data, evt));
    }

    function goSearch(e) {
        if (e != undefined) {
            e.preventDefault();
        }
        if (!data.query || data.query.length == 0) {
            toast.error(Translate(Message.PendingData));
        } else {
            setLoading(true)
            // DeliveryController.Search(data.query, userData.id, res => {
            // if (res.length > 0) {
            // setResults(res[0])
            // }
            FedexController.Get(data.query, result => {
                const base = result;
                if (base && base.output && base.output.completeTrackResults) {
                    const trackingResults = base.output.completeTrackResults[0].trackResults[0].scanEvents;

                    console.log("Resultado", base.output.completeTrackResults[0].trackingNumber);
                    const track = base.output.completeTrackResults[0].trackResults[0];
                    if (base.output.completeTrackResults[0].trackResults[0].originLocation && base.output.completeTrackResults[0].trackResults[0].originLocation.locationContactAndAddress) {
                        let baseData = {};
                        let origin = base.output.completeTrackResults[0].trackResults[0].originLocation.locationContactAndAddress.address;
                        let destination = base.output.completeTrackResults[0].trackResults[0].destinationLocation.locationContactAndAddress.address;

                        baseData.origin = {
                            ...origin,
                            country: origin.countryName,
                            state: origin.stateOrProvinceCode,
                            number: "",
                            street: "",
                            neighborhood: "",
                        };

                        baseData.destination = {
                            ...destination,
                            country: destination.countryName,
                            state: destination.stateOrProvinceCode,
                            number: "",
                            street: "",
                            neighborhood: "",
                        };


                        baseData.awb = base.output.completeTrackResults[0].trackingNumber;
                        baseData.id = base.output.completeTrackResults[0].trackingNumber;
                        // let box = {
                        //     weight: 0,
                        //     depth: 0,
                        //     height: 0,
                        //     width: 0,
                        //     name: "Volume 1"
                        // }

                        setResults(baseData);
                    }
                    let events = [];
                    let progress = 0;
                    let allEvents = track.scanEvents;

                    events.push({
                        icon: "fa fa-map-pin fa-2x",
                        title: Translate(Message.Origin),
                        origin: true,
                        description: `${track.shipperInformation.address.city} - ${track.shipperInformation.address.stateOrProvinceCode} ${track.shipperInformation.address.countryCode}`,
                    })

                    events.push({
                        icon: "",
                        title: "Coletado",
                        origin: false,
                        description: "-",
                    })

                    events.push({
                        icon: "",
                        title: "A caminho",
                        origin: false,
                        description: "-",
                    })

                    events.push({
                        icon: "",
                        title: "Saiu para entrega",
                        origin: false,
                        description: "-",
                    })


                    events.push({
                        icon: "fa fa-flag-checkered",
                        title: Translate(Message.Destination),
                        origin: false,
                        destiny: true,
                        description: `${track.recipientInformation.address.city} - ${track.recipientInformation.address.stateOrProvinceCode} ${track.recipientInformation.address.countryCode}`,
                    })
                    // for (let s in track.scanEvents) {
                    //     if (track.scanEvents[s].eventDescription == "Picked up") {
                    //         events[1].description = "Estamos com seu pacote";
                    //         events[1].title = "Coletado";
                    //         events[1].icon = "si si-social-dropbox";
                    //         events[2].date = track.scanEvents[s].date;
                    //     } else if (track.scanEvents[s].eventDescription == "On the way") {
                    //         events[2].description = "Estamos com seu pacote";
                    //         events[2].icon = "si si-social-dropbox";
                    //         events[2].date = track.scanEvents[s].date;
                    //     } else {
                    //         console.log("Nem vi", track.scanEvents[s]);

                    //     }
                    // }


                    const result = FedexHelper.ProcessEvents(track.scanEvents, events, track.dateAndTimes != null ? track.dateAndTimes : []);

                    setTimeline(result.events);
                    setProgress(result.progress);
                    setLoading(false);
                    setData({ ...data, fromQuery: false });
                }
            }, error => console.log("Error ", error))
            // }, error => console.log("Error ", error));

        }
    }

    function openDelivery(item) {
        setDeliveryId(item.id);
        setShowModal(true);
    }

    return (
        <div className="content row mt-3">
            {userData != null ?
                <div className="col-md-12" onClick={() => Functions.GoHome()}>
                    <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> {Translate(Message.Menu.Tracking)}</h3>
                </div>
                : ""}
            <div className="form-group col-md-12 block block-fx-pop block-rounded">
                <form onSubmit={e => goSearch(e)}>
                    <div className="block-content">
                        <div className="form-group">
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Pesquisar entrega..." name="query" value={data && data.query} onChange={evt => handleChange(evt)} />
                                <div className="input-group-append" onClick={() => goSearch()}>
                                    <button className="btn btn-dual">
                                        <i className="fa fa-search"></i> Pesquisar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            {timeline && timeline.length > 0 ?
                <div className="col-md-6">
                    <div className="block-header mb-0 pb-0">
                        <div className="block-title">
                            <h2 className="content-heading font-w700">{Translate(Message.History)}</h2>
                        </div>
                    </div>
                    <div className="d-flex">
                        {/* {CheckMobile() == false ?
                            <div className="progress mb-1" style={{ height: 6, transform: "rotate(90deg)", width: 470, marginTop: 235, marginLeft: -150 }}>
                                <div className="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            : ""} */}
                        {/* {CheckMobile() == true ? */}

                        <div class="row">

                            <div class="col-md-12 col-lg-12">
                                {/* <div id="tracking-pre"></div> */}
                                <div id="tracking">
                                    <div class="tracking-list">
                                        {/* <div class="tracking-item">
                                                <div class="tracking-icon status-intransit ml-3">
                                                    <span className={`overlay-item item item-circle border border-2x border-white timeline-event-icon bg-success`} style={{ marginLeft: 50 }}>
                                                        <i className={timeline[0].icon} />
                                                    </span>
                                                </div>
                                                <div class="tracking-content">Order Placed<span>09 Aug 2025, 10:00am</span></div>
                                            </div> */}
                                        {timeline && timeline.map(item => (
                                            <div class={item.done == true ? "tracking-item" : "tracking-item-pending"}>
                                                {item.icon ?
                                                    <div class="tracking-icon status-intransit ml-3">
                                                        <span className={`overlay-item item item-circle border border-2x border-white timeline-event-icon bg-success`}>
                                                            <i className={item.icon} />
                                                        </span>
                                                    </div>
                                                    :
                                                    <div class="tracking-icon status-intransit">
                                                        <svg class="svg-inline--fa fa-circle fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
                                                            <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                                                        </svg>
                                                    </div>
                                                }
                                                <div class="tracking-content">{item && item.title ?
                                                    <b>{item.title} <br /></b>
                                                    : ""}
                                                    {item && item.description}<span>{item && item.date && DateTranslate(item.date)}</span></div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* : */}
                        {/* <div style={{ marginLeft: -270, height: 350 }}>
                                <div className="media" style={{ top: 0, position: "absolute", marginTop: 80, marginLeft: 15 }}>
                                    <div className="mr-5 overlay-container overlay-left">
                                        <span className={`overlay-item item item-circle border border-2x border-white timeline-event-icon bg-success`}>
                                            <i className={timeline[0].icon} />
                                        </span>
                                    </div>
                                    <div className="media-body ml-2 mb-3 mt-0">
                                        <span className="">
                                            {timeline && timeline[0].title ?
                                                <b>{timeline[0].title} <br /></b>
                                                : ""}
                                            {timeline && timeline[0].description}
                                        </span>
                                        {timeline[0].date ?
                                            <span className="col-6 text-right">
                                                {timeline && DateTranslate(timeline[0].date)}
                                            </span>
                                            : ""}
                                    </div>
                                </div>

                                <div className="media" style={{ marginTop: 80, marginBottom: 30, marginLeft: timeline[1].icon.length == 0 ? 30 : 15, overflow: "hidden" }}>
                                    <div className="mr-5 overlay-container overlay-left">
                                        <span className={`overlay-item item ${!timeline[1].icon ? "item-tiny" : ""} item-circle border border-2x border-white timeline-event-icon bg-success`}>
                                            <i className={timeline && timeline[1].icon} />
                                        </span>
                                    </div>
                                    <div className="media-body ml-2 mb-3 mt-0">
                                        <span className="">
                                            {timeline && timeline[1].title ?
                                                <b>{timeline[1].title} <br /></b>
                                                : ""}
                                            {timeline && timeline[1].description}
                                        </span>
                                        {timeline && timeline[1].date ?
                                            <span className="col-6 text-right">
                                                {timeline && DateTranslate(timeline[1].date)}
                                            </span>
                                            : ""}
                                    </div>
                                </div>

                                <div className="media" style={{ marginTop: 60, marginBottom: 10, marginLeft: timeline[2].icon.length == 0 ? 30 : 15, overflow: "hidden" }}>
                                    <div className="mr-5 overlay-container overlay-left">
                                        <span className={`overlay-item item ${!timeline[2].icon ? "item-tiny" : ""} item-circle border border-2x border-white timeline-event-icon bg-success`}>
                                            <i className={timeline && timeline[2].icon} />
                                        </span>
                                    </div>
                                    <div className="media-body ml-2 mb-3 mt-0">
                                        <span className="">
                                            {timeline && timeline[2].title ?
                                                <b>{timeline[2].title} <br /></b>
                                                : ""}
                                            {timeline && timeline[2].description}
                                        </span>
                                        {timeline && timeline[2].date ?
                                            <span className="col-6 text-right">
                                                {timeline && DateTranslate(timeline[2].date)}
                                            </span>
                                            : ""}
                                    </div>
                                </div>

                                <div className="media" style={{ marginTop: 60, marginBottom: 15, marginLeft: timeline[3].icon.length == 0 ? 30 : 15, overflow: "hidden" }}>
                                    <div className="mr-5 overlay-container overlay-left">
                                        <span className={`overlay-item item ${!timeline[3].icon ? "item-tiny" : ""} item-circle border border-2x border-white timeline-event-icon bg-success`}>
                                            <i className={timeline && timeline[3].icon} />
                                        </span>
                                    </div>
                                    <div className="media-body ml-2 mb-3 mt-0">
                                        <span className="">
                                            {timeline && timeline[3].title ?
                                                <b>{timeline[3].title} <br /></b>
                                                : ""}
                                            {timeline && timeline[3].description}
                                        </span>
                                        {timeline && timeline[3].date ?
                                            <span className="col-6 text-right">
                                                {timeline && DateTranslate(timeline[3].date)}
                                            </span>
                                            : ""}
                                    </div>
                                </div>

                                <div className="media" style={{ marginTop: 40, marginLeft: 15, overflow: "hidden" }}>
                                    <div className="mr-5 overlay-container overlay-left">
                                        <span className={`overlay-item item item-circle border border-2x border-white timeline-event-icon bg-success`}>
                                            <i className={timeline[timeline.length - 1].icon} />
                                        </span>
                                    </div>
                                    <div className="media-body ml-2 mb-3 mt-0">
                                        <span className="">
                                            {timeline && timeline[timeline.length - 1].title ?
                                                <b>{timeline[timeline.length - 1].title} <br /></b>
                                                : ""}
                                            {timeline && timeline[timeline.length - 1].description}
                                        </span>
                                        {timeline[timeline.length - 1].date ?
                                            <span className="col-6 text-right">
                                                {timeline && DateTranslate(timeline[timeline.length - 1].date)}
                                            </span>
                                            : ""}
                                    </div>
                                </div>
                            </div> */}
                        {/* } */}
                    </div>
                </div>
                : ""
            }
            <div className="col-md-6">
                {results && results.id ?
                    <div className="block">
                        <div className="block-header mb-0 pb-0">
                            <div className="block-title">
                                <h2 className="content-heading font-w700">{Translate(Message.Address)}</h2>
                            </div>
                        </div>
                        <div className="block-fx-pop media-body ml-3 mb-3">
                            <div className="block-title">
                                <p>
                                    <i className="text-success fa fa-map-pin mr-3" />
                                    {Translate(Message.Origin)} {" "}
                                    <b>{results && results.origin && `${results.origin.number ? `${results.origin.number},` : ""} ${results.origin.street ? `${results.origin.street},` : ""} ${results.origin.neighborhood ? `${results.origin.neighborhood} - ` : ""} ${results.origin.city} - ${results.origin.state} - ${results.origin.country}`}</b>
                                </p>
                                {results && results.origin && results.origin.references ?
                                    <span>
                                        <b>{Translate(Message.References)}:</b>{results.origin.references}
                                    </span>
                                    : ""}
                            </div>
                        </div>
                        <div className="block-fx-pop media-body ml-3 mb-0">
                            <div className="block-title">
                                <p>
                                    <i className="text-success fa fa-flag-checkered mr-3" />
                                    {Translate(Message.Destination)} {" "}
                                    <b>{results && results.destination && `${results.destination.number ? `${results.destination.number},` : ""} ${results.destination.street ? `${results.destination.street},` : ""} ${results.destination.neighborhood ? `${results.destination.neighborhood} - ` : ""} ${results.destination.city} - ${results.destination.state} - ${results.destination.country}`}</b>
                                </p>
                                {results && results.destination && results.destination.references ?
                                    <span>
                                        <b>{Translate(Message.References)}:</b>{results.destination.references}
                                    </span>
                                    : ""}
                            </div>
                        </div>
                        {results && results.boxes ?
                            <div>
                                <div className="block-header pt-0 mt-0 mb-0 pb-0">
                                    <div className="block-title">
                                        <h2 className="content-heading font-w700">{Translate(Message.Package)}{results && results.boxes && results.boxes.length > 1 ? "s" : ""}</h2>
                                    </div>
                                </div>
                                <div className="block-content mt-0 pt-0">
                                    {results && results.boxes && results.boxes.map(item => (
                                        <BoxItem presentation={true} data={item} />
                                    ))}
                                </div>
                            </div>
                            : ""}
                        {results && results.files ?
                            <div>
                                <div className="block-header mb-0 pb-0">
                                    <div className="block-title">
                                        <h2 className="content-heading font-w700">{Translate(Message.Menu.Documents)}</h2>
                                    </div>
                                </div>
                                <div className="block-content mt-0 pt-0">
                                    {results && results.files && results.files.map(item => (
                                        <div className="block block-fx-pop block-bordered border-success mt-1">
                                            <div className="block-header">
                                                <div className="block-title">
                                                    <i className="far fa-file-pdf text-success mr-2" /> {item.name}
                                                </div>
                                                <div className="block-tools">
                                                    <a className="btn btn-hero-success btn-sm" href={item.url} target="_blank"><i className="si si-cloud-download mr-1" /> Download</a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            : ""}
                    </div>
                    : ""}
            </div>
            {
                loading === true ? (
                    <div className="col-12 block-content text-center">
                        <i className={"fa fa-circle-notch fa-2x fa-spin text-info"}></i>
                    </div>
                ) : (
                    ""
                )
            }
            <DeliveryModal
                show={showModal}
                deliveryId={deliveryId}
                onHide={() => setShowModal(false)}
            />
        </div >
    )
}